import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserContext } from '@hooks/context/useUserContext';
import { EUserRole } from '@xeppt/xeppt-sdk/types';
import { routes } from '@const/routes';

const ComplianceGuard = () => {
    const { user, isDataLoading } = useUserContext();

    // Wait until the profile has actually loaded before deciding. On a direct
    // deep-link / refresh of an AML page, `user` is undefined on the first
    // render (the profile fetch hasn't fired yet); redirecting then would bounce
    // a legitimate Compliance Officer away. Hold render until `user` is known —
    // a genuine auth failure is redirected to sign-in by UserContext.
    if (isDataLoading || !user) {
        return null;
    }

    if (
        user?.role === EUserRole.COMPLIANCE_OFFICER ||
        user?.role === EUserRole.SUPER_ADMIN
    ) {
        return <Outlet />;
    }

    return <Navigate to={routes.transactions} replace />;
};

export default ComplianceGuard;
